import useTenant from "../src/useTenant";
import Schedule1x1Cta from "./Schedule1x1Cta";

const ProductionOnlySettings: React.FC<{
  youCannot: string;
  youWillBeAbleTo: string;
  utmContent: string;
}> = ({ youCannot, youWillBeAbleTo, utmContent, children }) => {
  const { tenant } = useTenant();

  return (
    <>
      {tenant?.kind === "production" ? (
        children
      ) : (
        <div className="bg-gray-100 border rounded p-4 flex items-center space-x-3">
          <div className="leading">
            You cannot {youCannot}{" "}
            <span className="text-xs text-white rounded font-bold bg-gray-500 uppercase py-0.5 px-1">
              developer
            </span>{" "}
            organizations.
            <div className="mt-1">
              To set up a{" "}
              <span className="text-xs text-white rounded font-bold bg-green-700 uppercase py-0.5 px-1">
                business
              </span>{" "}
              organization and {youWillBeAbleTo},{" "}
              <Schedule1x1Cta
                utmContent={utmContent}
                utmSource="app"
                className="underline text-blue-800"
              >
                set up a 1x1 with an Oso engineer
              </Schedule1x1Cta>
              .
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductionOnlySettings;
